import { useAuthStore } from '@/stores/authStore';

/**
 * Hook to get current authenticated user
 */
export function useUser() {
  const { user, session } = useAuthStore();

  return {
    user,
    session,
    isAuthenticated: !!user,
  };
}
